import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_stock_level_monitoring_template_entity_link_RowClass } from '../../../dbschema/bl_inv_stock_level_monitoring_template_entity_link.model';

export class StockLevelMonitoringTemplateEntityLinkModel extends BaseContainerModel {
  bl_inv_stock_level_monitoring_template_entity_link: bl_inv_stock_level_monitoring_template_entity_link_RowClass = new bl_inv_stock_level_monitoring_template_entity_link_RowClass();
}
